import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class LoginResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("LoginResourcePackage");
    }
    public get assets_views_login_login_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/login/login-0_1x.atlas.json");
    }
    public get assets_views_login_main_login_screen_main_login_background_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["main_login_screen/main_login_background.png"];
    }
    public get assets_views_login_verificationFailed_failed_background_jpg(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["verificationFailed/failed_background.jpg"];
    }
    public get assets_views_login_connectWallet_footer_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["connectWallet/footer.png"];
    }
    public get assets_views_login_connectWallet_light_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["connectWallet/light.png"];
    }
    public get assets_views_login_text_field_frame_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["text_field_frame.png"];
    }
    public get assets_views_login_connectWallet_separator_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["connectWallet/separator.png"];
    }
    public get assets_views_login_buttons_mail_login_button_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["buttons/mail_login_button.png"];
    }
    public get assets_views_login_buttons_black_button_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["buttons/black_button.png"];
    }
    public get assets_views_login_login_failed_icons_email_icon_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["login_failed_icons/email_icon.png"];
    }
    public get assets_views_login_buttons_passkey_icon_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["buttons/passkey_icon.png"];
    }
    public get assets_views_login_main_login_screen_mail_icon_png(): Texture {
        return this.assets_views_login_login_0_1x_atlas_json.textures["main_login_screen/mail_icon.png"];
    }
    public get assets_views_login_login_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/login/login-0_1x.atlas.png");
    }
    public get assets_views_login_login_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/login/login-1_1x.atlas.json");
    }
    public get assets_views_login_verificationFailed_glas_tooltip_frame_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["verificationFailed/glas_tooltip_frame.png"];
    }
    public get assets_views_login_connectWallet_frame_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["connectWallet/frame.png"];
    }
    public get assets_views_login_verificationFailed_tooltip_orange_shape_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["verificationFailed/tooltip_orange_shape.png"];
    }
    public get assets_views_login_verificationFailed_tooltip_purple_shape_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["verificationFailed/tooltip_purple_shape.png"];
    }
    public get assets_views_login_main_login_screen_login_logo_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["main_login_screen/login_logo.png"];
    }
    public get assets_views_login_buttons_button_blue_big_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["buttons/button_blue_big.png"];
    }
    public get assets_views_login_buttons_button_green_blue_big_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["buttons/button_green_blue_big.png"];
    }
    public get assets_views_login_buttons_button_green_long_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["buttons/button_green_long.png"];
    }
    public get assets_views_login_buttons_button_green_png(): Texture {
        return this.assets_views_login_login_1_1x_atlas_json.textures["buttons/button_green.png"];
    }
    public get assets_views_login_login_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/login/login-1_1x.atlas.png");
    }
}

